import React from "react";
import html2canvas from "html2canvas";

const ScreenShot = async (element: any, options = {}) => {
    const canvas = await html2canvas(element, options);
    return canvas.toDataURL(); // Returns the data URL of the screenshot image
  };
  
  export default ScreenShot;